<sc-activity-list-item [activity]="activity" [condensed]="condensed" [showProjectName]="context == 'candidate'">
    <i scActivityIcon class="fa-sharp fa-solid fa-xmark"></i>
    @if (context != 'project') {
    {{ texts.referenceRejectedShort[language] }}
    } @else {
    {{ texts.referenceRejectedPrefix[language] }} <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> {{ texts.referenceRejectedSuffix[language] }}
    }
</sc-activity-list-item>
